/* global connect React Component */
import mixinsFunc from "../mixins";
export class DocUpload extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("DocUpload");
    let mixins = mixinsFunc(this);
    this.state = {
      links: mixins.links || [],
      docList: [],
      shareHolders: [mixins.docInfo],
      fields: {
        docInfo: mixins.docInfo,
      },
    };
  }

  addShareHolder() {
    let mixins = mixinsFunc(this);
    let shareHolders = this.state.shareHolders;
    shareHolders.push(mixins.docInfo);
    this.setState({ shareHolders: [...shareHolders] });
  }

  deleteShareHolder(index) {
    let shareHolders = this.state.shareHolders.filter((o, i) => i != index);
    this.setState({ shareHolders });
  }

  AddShareHolder(props) {
    return (
      <button
        type="button"
        className="btn btn-outline-warning border-0 d-flex align-items-center"
        onClick={() => props.addShareHolder()}
      >
        <i className="fa fa-plus mx-2"></i>
        Add Shareholder
      </button>
    );
  }

  breadCumRight() {
    return <AppStepper index={4} count={5}></AppStepper>;
  }

  getBusinessData() {
    let mixins = mixinsFunc(this);
    return new Promise((resolve, reject) => {
      this.api
        .execApi("getBusiness")
        .then(async (response) => {
          let data = response.data;
          let rows = data.items || [];
          let infoData = await this.getCompanyData();
          this.setState(
            (state) => ({
              list: rows,
              shareHolders: (rows || state.shareHolders).map((data, i) => {
                data["snum"] = i + 1;
                return mixins.docInfo.map((o) => ({
                  ...o,
                  "data-director_id": data.director_id,
                  defaultValue: data[o.name] ?? "",
                }));
              }),
            }),
            resolve
          );
        })
        .catch(reject);
    });
  }

  getDocumentsAll() {
    return new Promise((resolve, reject) => {
      this.api
        .apiGetDocumentsAll()
        .then((list) => {
          this.setState(
            (state) => ({
              docList: list.profile,
            }),
            () => resolve(list.profile)
          );
        })
        .catch(() => {
          this.setState(
            (state) => ({
              docList: [],
            }),
            () => resolve([])
          );
        });
    });
  }

  componentDidMount() {
    this.getBusinessData();
    this.getDocumentsAll();
  }

  saveDocInfo(e) {
    let id = e.target.querySelector("input").dataset.id;
    let row = this.state.list.find((o, i) => o.director_id == id);
    if (row) {
      let payload = { director_id: row.director_id, ...data };
      this.api.execApi("putBusiness", payload).then(() => {
        this.getBusinessData().then(() => {
          success("Update Successfull");
        });
      });
    } else {
      this.api
        .execApi("postBusiness", data)
        .then(() => {
          this.getBusinessData().then(() => {
            success("Add Successfull");
          });
        })
        .catch((err) => {
          console.log({ err });
          this.deleteShareHolder(index);
        });
    }
  }

  getCompanyData() {
    return new Promise((resolve, reject) => {
      this.api
        .execApi("getCompany")
        .then((response) => {
          let data = response.data;
          this.setState(
            (state) => ({
              infoData: data,
            }),
            () => resolve(data)
          );
        })
        .catch(reject);
    });
  }

  submitRecord() {
    if (this.state.docList.length >= this.state.shareHolders.length * 2) {
      success("Upload Successfull").promise.then(() => {
        navigate("/app/profile/credit_rating");
      });
    } else {
      failure("Please upload all neccessory documents");
    }
  }

  uploadDocument(input, field, index) {
    let [file] = input.files;
    let type = input.dataset.doctype;
    let director_id = input.dataset.director_id;
    this.api.execApi(
      "postDocuments",
      {
        director_id,
        file,
        type,
        doc_meta_name: JSON.stringify({
          name: field.name,
          type,
          director_id,
          group: "profile",
        }).encode(),
      },
      {},
      {
        multipart: true,
        message: "Uploading please wait...",
        onexec: () => {
          success("Upload Successfull").promise.then(() => {
            this.getDocumentsAll();
          });
        },
      }
    );
  }

  getFile(name, director_id) {
    return this.state.docList.find(
      (o) =>
        o.doc_meta_name.name == name &&
        o.doc_meta_name.director_id == director_id
    );
  }
  getFileAttrs(field) {
    let file = this.getFile(field.name, field["data-director_id"]);
    if (this.state.docList.length) {
      console.log(
        { file, field },
        field.name,
        field["data-director_id"],
        this.state.docList
      );
    }

    return {
      isuploaded: !!file,
      labelname: file?.file_name,
    };
  }

  downloadDocument(args) {
    let file = this.getFile(args.name, args["data-director_id"]);
    console.log(file);

    if (file) {
      this.api
        .execApi(
          "getDocuments",
          {},
          {
            attachment_id: file.attachment_id,
          }
        )
        .then((response) => {
          console.log({ download: response });
        });
    }
  }

  deleteDocument(attrs, callback) {
    let file = this.getFile(attrs.name, attrs["data-director_id"]);
    console.log(
      "deleteDocument",
      attrs.name,
      attrs["data-director_id"],
      file,
      attrs
    );
    if (file) {
      this.api
        .execApi(
          "deleteDocuments",
          {},
          {
            attachment_id: file.attachment_id,
          }
        )
        .then(() => {
          this.getDocumentsAll();
        });
    }
  }

  render() {
    let { AddShareHolder, breadCumRight } = this;
    let { links, fields, shareHolders } = this.state;
    const isNotIndv = this.state.infoData?.company_type !== "indv";
    const isPvtLtd = this.state.infoData?.company_type === "ppc";

    if (isPvtLtd) {
      shareHolders = shareHolders.map((fild) =>
        fild.map((o) => ({
          ...o,
          ...(o.name == "director_name"
            ? {
                label: "Director Name",
              }
            : {}),
        }))
      );
    }
    /* eslint-disable-next-line react/jsx-no-undef */

    return (
      <AppWrapper
        customTitle="Update Profile"
        title="Profile"
        slots={{ breadCumRight }}
      >
        <AppLinkTabs data={links}></AppLinkTabs>
        <div className="card">
          <div className="card-body">
            <div>
              {shareHolders.map((fields, i) => (
                <AppForm
                  key={i}
                  onSubmit={(...args) => this.saveDocInfo(i, ...args)}
                >
                  <Row className="mx-0">
                    {fields.map((field, j) => (
                      <Col key={j + field.name} className={field.fieldclass}>
                        <AppInput
                          {...field}
                          {...(field.type == "file"
                            ? this.getFileAttrs(field)
                            : {})}
                          onChange={(e) =>
                            this.uploadDocument(e.target, field, i)
                          }
                          onDelete={(...args) => this.deleteDocument(...args)}
                          onDownload={(...args) =>
                            this.downloadDocument(...args)
                          }
                        ></AppInput>
                      </Col>
                    ))}
                    {/* <Col>
                      <button
                        className="square_delete_btn btn add-btn my-auto relative bottom-[-33px]"
                      >
                        <i className="fa fa-check"></i>
                      </button>
                    </Col> */}
                  </Row>
                </AppForm>
              ))}
              {/* <AddShareHolder addShareHolder={() => this.addShareHolder()} /> */}
              <div>
                <Row>
                  <Col className="text-right">
                    <button
                      className="btn add-btn"
                      onClick={() => this.submitRecord()}
                    >
                      Save & Next
                    </button>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </AppWrapper>
    );
  }
}

export default connect(DocUpload);
